import React from 'react'
import { Route, Routes } from 'react-router-dom'
import PrivateRoute7  from '../../app/routes/PrivateRoute7'

import ListAlternative from './ListAlternative'

import EditAlternative from './EditAlternative'
import NewAlternative from './NewAlternative'

const SpecialistAlternativeRoutes = () => {

  return (
    <Routes>
        <Route path="/" element={<PrivateRoute7><ListAlternative /></PrivateRoute7>} />
        <Route path="edit-alternative" element={<PrivateRoute7><EditAlternative /></PrivateRoute7>} />
        <Route path="new-alternative" element={<PrivateRoute7><NewAlternative /></PrivateRoute7>} />
    </Routes>
  )
}

export default SpecialistAlternativeRoutes